import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@saviynt/design-system';

import { CertsListSecondaryHeader } from '../../../components/CertsList';
import CertsListHeaderControls from '../../../components/CertsList/CertsListHeaderControls';
import CertsListHeaderTabs from '../../../components/CertsList/CertsListHeaderTabs';

import './CertsListHeader.css';

function CertsListHeader() {
  const tabsAndControlsRef = useRef(null);

  const {
    core: { isPageLoadFinished },
  } = useSelector((state) => state?.certifications?.list);

  return (
    <Box className='CertsListHeader'>
      {isPageLoadFinished && <CertsListSecondaryHeader />}
      <Box ref={tabsAndControlsRef} className='CertsListHeader-tabsAndControls'>
        <CertsListHeaderTabs tabsAndControlsRef={tabsAndControlsRef} />
        <CertsListHeaderControls />
      </Box>
    </Box>
  );
}

export default CertsListHeader;
